import { FileEntity } from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  publicLinkId: string;
  formId: number;
  fileEntities: FileEntity[];
}

export const modifyPublicLinkCustomFormReportFormFileFieldsRequest = ({
                                                                        formId,
                                                                        publicLinkId,
                                                                        fileEntities,
                                                                      }: RequestParams): Promise<void> => {
  return ApiServiceInstance.makeRequest(`/custom-form-report/public-link/${ publicLinkId }/${formId}/file-fields`, {
    method: 'PUT',
    body: fileEntities,
  });
};